import React from 'react'
import type { IconProps } from '@phosphor-icons/react'

type DashboardCustomizeIconProps = React.SVGProps<SVGSVGElement> & {
  weight?: IconProps['weight']
}

export const DashboardCustomizeIcon = ({
  className,
  weight: _weight,
  ...props
}: DashboardCustomizeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='currentColor'
      viewBox='0 0 256 256'
      className={className}
      {...props}
    >
      {/* Three circles */}
      <path d='M80,40a40,40,0,1,0,40,40A40,40,0,0,0,80,40Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,80,104Zm96,16a40,40,0,1,0-40-40A40,40,0,0,0,176,120Zm0-64a24,24,0,1,1-24,24A24,24,0,0,1,176,56ZM80,136a40,40,0,1,0,40,40A40,40,0,0,0,80,136Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,80,200Z' />
      {/* Plus sign - will rotate 90deg on hover */}
      <g
        style={{
          transformOrigin: '176px 176px',
          transition: 'transform 0.3s ease-in-out',
        }}
        className='group-hover:rotate-90'
      >
        <path d='M216,176a8,8,0,0,1-8,8H184v24a8,8,0,0,1-16,0V184H144a8,8,0,0,1,0-16h24V144a8,8,0,0,1,16,0v24h24A8,8,0,0,1,216,176Z' />
      </g>
    </svg>
  )
}

